export class Price {
	static seperate = (value = 0) => {
		if (!Number(value) || (!isNaN(Number(value)) && value < 1)) return value;

		const seperated = String(value)
			.replaceAll(',', '')
			.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');

		const sepratedArray = seperated.split('.');
		sepratedArray.map((item, i) => (i > 0 ? (sepratedArray[i] = sepratedArray[i].replaceAll(',', '')) : null));

		return sepratedArray.join('.');
	};

	static seperateDash = (value = 0) => {
		if (!isNaN(value) && value < 1) return value;

		return String(value)
			.replaceAll('-', '')
			.replace(/(\d)(?=(\d\d\d\d)+(?!\d))/g, '$1-');
	};
}
